import moment from "moment";
import RecordClassCreator from "services/record";

export default class StatsConversationsOverviewRecord extends RecordClassCreator({
  type: "statsConversationsOverviewRecord",

  /** @memberof StatsConversationsOverviewRecord# */
  date: undefined,

  /** @memberof StatsConversationsOverviewRecord# */
  total: undefined,

  /** @memberof StatsConversationsOverviewRecord# */
  engaged: undefined,

  /** @memberof StatsConversationsOverviewRecord# */
  handoff: undefined,

  /** @memberof StatsConversationsOverviewRecord# */
  timeSeriesUnit: "day"
}) {
  /**
   * @returns {String}
   */
  get chartAxisLabel() {
    switch (this.timeSeriesUnit) {
      case "month": return moment(this.date).format("MMM 'YY");
      case "week": return moment(this.date).format("MMM D");
      default: return moment(this.date).format("MMM D");
    }
  }

  /**
   * @returns {String}
   */
  get tooltipLabel() {
    const date = moment(this.date);

    switch (this.timeSeriesUnit) {
      case "month":
        return date.format("MMMM, YYYY");
      case "week":
        return `Week of ${date.format("MMMM D, YYYY")}`;
      default:
        return date.format("dddd, MMMM D, YYYY");
    }
  }

  /**
   * @returns {String}
   */
  get tableLabel() {
    const date = moment(this.date);

    switch (this.timeSeriesUnit) {
      case "month":
        return date.format("MMMM, YYYY");
      case "week":
        return `Week of ${date.format("MMM D, YYYY")}`;
      default:
        return date.format("MMMM D, YYYY");
    }
  }
}
